import axios from "axios";
import Qs from "qs";
import { Message } from "element-ui";
import store from "../store";

// axios.defaults.withCredentials = true; //等同于在封装的实例里面设置

let baseURL = process.env.API_ROOT;

//axios配置
let axiosConfig = {
  baseURL,
  timeout: 30000000, //请求发出的延迟，超过延迟的时间，那么请求会被终止
  transformRequest: [
    function(data) {
      // formData格式，直接返回不做格式转换
      if (data instanceof FormData) {
        return data;
      }
      data = Qs.stringify(data);
      return data;
    },
  ],
  withCredentials: true,
};

let instanceTmp = axios.create(axiosConfig);

// http请求拦截器
instanceTmp.interceptors.request.use(
  (config) => {
    // element ui Loading方法
    return config;
  },
  (error) => {
    Message.error({
      message: "加载超时",
    });
    return Promise.reject(error);
  }
);

// http响应拦截器
instanceTmp.interceptors.response.use(
  (response) => {
    // 响应成功关闭loading
    const res = response.data;
    if (res.code == "5") {
      // store.state.maskBox = true
      store.commit("toggleMaskState", true);
      // let text1 = '', text2 = '',text3 = '',text4 = ''
      // if(localStorage.getItem('zhOren') == 'zh'){
      //   text1 = '登录信息已过期，请重新登录';
      //   text2 = '确定登出';
      //   text3 = '重新登录'
      //   text4 = '取消'
      // }else{
      //   text1 = 'Session timeout, please login again';
      //   text2 = 'Confirm logout';
      //   text3 = 'Re login'
      //   text4 = 'cancel'
      // }
      // MessageBox.confirm(text1, text2, {
      //   confirmButtonText: text3,
      //   cancelButtonText: text4,
      //   type: 'warning'
      // }).then(() => {
      //   location.href = 'https://home.codingolympics.cn/#/signIn'
      //   //调用注销，跳转登录页
      //   // axios(process.env.API_ROOT+'/user/logout', {
      //   //   method: 'post'
      //   // }).then((res) => {
      //   //   var res = res.data;
      //   //   if(res.code == '0'){
      //   //     localStorage.clear()
      //   //     Vue.$router.push({ path:'/'})
      //   //   }
      //   // });
      // })
      return Promise.reject("error");
    } else {
      return response;
    }
  },
  (error) => {
    console.log("888");
    return Promise.reject(error);
  }
);

export default {
  getAxios: instanceTmp,
};



// WEBPACK FOOTER //
// ./src/service/HttpService.js